const { same } = require('../utils');

exports.computePlaceholderBorderStrokeFromTextBodies = textBodies => same(textBodies, 'placeholderBorderStroke', 0);
